import { mesaColorNames } from '@/src/common/theme'
import Svg, { Path, type SvgProps } from 'react-native-svg'

export function Notifications(props: SvgProps) {
  return (
    <Svg fill="none" viewBox="0 0 24 24" {...props}>
      <Path
        stroke={props.color ?? mesaColorNames['Mesa - Brand/Blackish #222222']}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={props.strokeWidth ?? 1.5}
        d="M13.375 19.203a1.6 1.6 0 0 1-2.768 0M16.79 8.8a4.799 4.799 0 1 0-9.6 0c0 4.199-3.74 4.913-2.4 6.699 1.34 1.786 13 2 14.5 0 1.305-1.74-2.5-2.5-2.5-6.7Z"
      />
    </Svg>
  )
}
